export class ButtonHarnessController {
  // @ngInject
  constructor(private $element: ng.IAugmentedJQuery) {}

  public handleClick($event: ng.IAngularEvent) {
    $event.preventDefault();
    $event.stopPropagation();
  }

  public alertError($event: ng.IAngularEvent) {
    alert("should not be hit");
  }
}
